document.addEventListener("DOMContentLoaded", () => {
  console.log("[like-dislike-btn.js] Loaded.");

  const likeBtn = document.getElementById("likeBtn");
  const dislikeBtn = document.getElementById("dislikeBtn");

  let isLiked = false;
  let isDisliked = false;
  let likeCount = 0;

  let likeIcon = null;
  let reactionCountSpan = null;
  let dislikeIcon = null;

  // ------------------------------
  // 1. READ FROM LOCALSTORAGE (once)
  // ------------------------------
  const storedCount = localStorage.getItem("likeCount");
  const storedLikeState = localStorage.getItem("likeState");
  const storedDislikeState = localStorage.getItem("dislikeState");

  if (storedCount !== null) {
    likeCount = parseInt(storedCount, 10) || 0;
  }
  if (storedLikeState === "true") {
    isLiked = true;
  }
  if (storedDislikeState === "true") {
    isDisliked = true;
  }

  // ------------------------------
  // LIKE BUTTON SETUP
  // ------------------------------
  if (likeBtn) {
    console.log("[likeBtn] Found in DOM.");

    likeIcon = likeBtn.querySelector("img[data-icon]");
    reactionCountSpan = likeBtn.querySelector(".reaction-count");

    // If there's a reaction-count in DOM, parse its initial text
    // (But we already loaded from localStorage above, so treat DOM as fallback)
    if (reactionCountSpan) {
      const domCount = parseInt(reactionCountSpan.textContent || "0", 10);
      // If localStorage was empty, we rely on the DOM’s count
      if (storedCount === null) {
        likeCount = domCount;
      }
    }

    // Like button click
    likeBtn.addEventListener("click", () => {
      console.log("[likeBtn] clicked. wasLiked?", isLiked);
      const newLikeState = !isLiked;

      // Increment or decrement
      if (newLikeState) {
        likeCount++;
      } else {
        likeCount--;
      }

      // If toggling Like on and Dislike was active => remove Dislike
      let newDislikeState = isDisliked;
      if (newLikeState && isDisliked) {
        newDislikeState = false;
      }

      isLiked = newLikeState;
      isDisliked = newDislikeState;

      persistStates(isLiked, isDisliked, likeCount);
      updateUI(isLiked, isDisliked, likeCount);
    });
  }

  // ------------------------------
  // DISLIKE BUTTON SETUP
  // ------------------------------
  if (dislikeBtn) {
    console.log("[dislikeBtn] Found in DOM.");

    dislikeIcon = dislikeBtn.querySelector("img[data-icon]");

    // Dislike button click
    dislikeBtn.addEventListener("click", () => {
      console.log("[dislikeBtn] clicked. wasDisliked?", isDisliked);
      const newDislikeState = !isDisliked;
      let newLikeState = isLiked;
      let newCount = likeCount;

      // If turning on Dislike while Like is on => remove that Like
      if (newDislikeState && isLiked) {
        newLikeState = false;
        newCount = likeCount - 1;
      }

      isLiked = newLikeState;
      isDisliked = newDislikeState;
      likeCount = newCount;

      persistStates(isLiked, isDisliked, likeCount);
      updateUI(isLiked, isDisliked, likeCount);
    });
  }


  updateUI(isLiked, isDisliked, likeCount);

  function updateUI(liked, disliked, count) {
    console.log("[like-dislike-btn] updateUI =>", { liked, disliked, count });

    if (likeBtn) {
      // Reaction count
      if (reactionCountSpan) {
        reactionCountSpan.textContent = count;
        reactionCountSpan.style.display = count > 0 ? "inline-block" : "none";
      }
      // .active
      likeBtn.classList.toggle("active", liked);
      likeBtn.setAttribute("aria-pressed", liked ? "true" : "false");

      // data-force-theme for likeIcon
      if (likeIcon) {
        if (liked) {
          console.log("  => Setting data-force-theme=dark on likeIcon");
          likeIcon.setAttribute("data-force-theme", "dark");
        } else {
          console.log("  => Removing data-force-theme from likeIcon");
          likeIcon.removeAttribute("data-force-theme");
        }

        if (typeof window.applyTheme === "function") {
          window.applyTheme();
        }
      }
    }

    if (dislikeBtn) {
      dislikeBtn.classList.toggle("active", disliked);
      dislikeBtn.setAttribute("aria-pressed", disliked ? "true" : "false");

      if (dislikeIcon) {
        if (disliked) {
          console.log("  => Setting data-force-theme=dark on dislikeIcon");
          dislikeIcon.setAttribute("data-force-theme", "dark");
        } else {
          console.log("  => Removing data-force-theme from dislikeIcon");
          dislikeIcon.removeAttribute("data-force-theme");
        }

        if (typeof window.applyTheme === "function") {
          window.applyTheme();
        }
      }
    }
  }

  function persistStates(liked, disliked, count) {
    localStorage.setItem("likeCount", String(count));
    localStorage.setItem("likeState", String(liked));
    localStorage.setItem("dislikeState", String(disliked));
    console.log("[persistStates]", { liked, disliked, count });
  }
});
